import { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { useThemeMode } from '_metronic/partials'
import { formatGrandNumber } from 'Utils/numberFormat'

interface StackedPileChartProps {
  categories: string[]
  series: Array<{
    name: string
    data: number[]
  }>
  colors: string[]
}

const StackedPileChart: React.FC<StackedPileChartProps> = ({ categories, series, colors }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const chart = new ApexCharts(
      chartRef.current,
      getChartOptions(categories, series, colors, mode)
    )
    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshChart()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, categories, series, colors])

  return (
    <>
      <div
        ref={chartRef}
        id='kt_charts_stacked_pile_chart'
        style={{ height: '600px' }}
        className='card-rounded-bottom'></div>
    </>
  )
}

function getChartOptions (
  categories: string[],
  series: Array<{ name: string; data: number[] }>,
  colors: string[],
  mode: string
): ApexOptions {
  const textColor = mode === 'dark' ? '#A1A5B7' : '#7E8299'

  return {
    series: series,
    colors: colors,
    chart: {
      type: 'bar',
      height: 600,
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        borderRadius: 8,
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ['#000000'],
        fontSize: '10px',
        fontFamily: 'Helvetica, Arial, sans-serif',
        fontWeight: 'light',
      },
      offsetY: 0,
      formatter: function (val: number | string): string | number {
        return typeof val === 'number' ? formatGrandNumber(val) : val
      },
      textAnchor: 'middle',
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: categories,
      labels: {
        style: {
          colors: textColor,
        },
        rotate: -90,
        rotateAlways: true,
        offsetY: 0,
      },
    },
    yaxis: {
      title: {
        text: 'จำนวนต้นเสาเข็ม',
        style: {
          color: textColor,
        },
      },
      labels: {
        style: {
          colors: textColor,
        },
      },
    },
    fill: {
      opacity: 1,
    },
    // legend: {
    //   position: 'top',
    //   horizontalAlign: 'right',
    //   labels: {
    //     colors: textColor,
    //     useSeriesColors: false,
    //   },
    //   markers: {
    //     fillColors: colors,
    //     width: 0,
    //     height: 0,
    //   },
    //   // formatter: function (seriesName: string, opts: any) {
    //   //   const series = opts.w.config.series.find((s: any) => s.name === seriesName)
    //   //   const sum = series.data.reduce((a: number, b: number) => a + b, 0)
    //   //   return `<div style="font-weight: bold; font-size: 1.5rem;">${formatGrandNumber(
    //   //     sum
    //   //   )} เสา</div><span style="display: inline-block; width: 12px; height: 12px; margin-right: 5px; border-radius: 3px; background-color: ${
    //   //     opts.w.config.colors[opts.seriesIndex]
    //   //   };"></span>${seriesName}`
    //   // },
    // },
    tooltip: {
      y: {
        formatter: function (val) {
          return formatGrandNumber(val) + ' ต้น'
        },
      },
    },
  }
}

export default StackedPileChart
